import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import MessagingIcon from '@tradera/blueprint/theme/icons/mail.svg?jsx';
import MessagingButtonEmail from './messaging-button-email';
import uiActions from 'tradera-state/ui/actions';
import { logger } from 'packages';
import { withTranslator, withUrlLocalizer } from 'tradera-lang';

import {
    checkUserMessagingParticipation,
    getMessagingPageLink,
    getMessagingThreadLink
} from 'tradera-apps/my-tradera/app/helpers/messaging-helpers';

class MessagingButton extends React.Component {
    state = {
        buttonVisible: false
    };

    componentDidMount() {
        // Only show button if participation returns true
        checkUserMessagingParticipation(this.props.sellerId)
            .then(buttonVisible => {
                this.setState({
                    buttonVisible
                });
                return undefined;
            })
            .catch(err => {
                this.setState({
                    buttonVisible: false
                });
                logger(err);
            });
    }

    openMessagingModal = (title, src, participating) => {
        const { dispatch, isLoggedIn } = this.props;
        if (isLoggedIn) {
            dispatch(
                uiActions.openMessagingModal({ title, src, participating })
            );
        } else {
            this.handleLogin(src);
        }
    };

    handleLogin = href =>
        this.props.dispatch(uiActions.signIn({ redirectUrl: href }));

    render() {
        const {
            buyerId,
            buyerAlias,
            sellerId,
            itemId,
            source,
            mode,
            className,
            itemenddate,
            itemimageurl,
            itemtitle,
            receivermemberalias,
            isLoggedIn,
            memberId,
            toLocalizedUrl,
            t
        } = this.props;
        const { buttonVisible } = this.state;

        let href;
        if (buyerId && sellerId) {
            if (mode === 'modal') {
                href = getMessagingThreadLink(buyerId, sellerId, itemId, {
                    traderaUserId: memberId,
                    singleThread: true,
                    openForm: true,
                    source
                });
            } else {
                href = getMessagingPageLink(buyerId, sellerId, itemId, {
                    traderaUserId: memberId,
                    source
                });
            }
        } else {
            href = window.location.pathname;
        }

        const BUTTON_LABELS = {
            ask_seller: t('messaging_askTheSeller'),
            contact_seller: t('messaging_contactSeller'),
            contact_buyer: t('messaging_contactBuyer'),
            contact_seller_email: t('messaging_askTheSeller')
        };

        // Disable on user's own items
        const disableButton = buyerId === sellerId;

        const emailPayload = itemtitle
            ? {
                  modalTitle: BUTTON_LABELS['contact_seller_email'],
                  messageSubject: t('messaging_messageSubject', {
                      itemTitle: itemtitle
                  }),
                  itemEnddate: itemenddate,
                  itemId: itemId,
                  itemImageUrl: itemimageurl,
                  itemTitle: itemtitle,
                  receiverMemberAlias: receivermemberalias,
                  receiverMemberId: sellerId,
                  senderMemberAlias: buyerAlias,
                  businessWarning: true,
                  reloadAfterClose: false
              }
            : null;

        if (buttonVisible) {
            if (mode === 'modal') {
                return (
                    <div
                        className={`${
                            disableButton ? 'tooltip_container' : ''
                        }`}>
                        <button
                            className={`btn btn-outline-primary ${className}`}
                            onClick={() =>
                                this.openMessagingModal(
                                    BUTTON_LABELS[source],
                                    toLocalizedUrl(href),
                                    buttonVisible
                                )
                            }
                            disabled={disableButton}>
                            <MessagingIcon
                                className="icon icon-before"
                                style={{ verticalAlign: 'text-bottom' }}
                            />
                            <span className="default-label">
                                {BUTTON_LABELS[source]}
                            </span>
                        </button>
                        {disableButton && (
                            <span className="tooltip text-center">
                                {t('messaging_contactSelfText')}
                            </span>
                        )}
                    </div>
                );
            } else {
                return (
                    <a
                        className={`btn btn-outline-primary ${className}`}
                        href={toLocalizedUrl(href)}>
                        <MessagingIcon className="icon icon-before" />
                        <span className="default-label">
                            {BUTTON_LABELS[source]}
                        </span>
                    </a>
                );
            }
        } else {
            // Show fallback if email payload is provided
            if (emailPayload) {
                return (
                    <MessagingButtonEmail
                        label={BUTTON_LABELS['contact_seller_email']}
                        className={className}
                        emailPayload={emailPayload}
                        isLoggedIn={isLoggedIn}
                        handleLogin={this.handleLogin}
                    />
                );
            }
        }

        return null;
    }
}
MessagingButton.propTypes = {
    isLoggedIn: PropTypes.bool,
    memberId: PropTypes.string,
    className: PropTypes.string,
    buyerId: PropTypes.string.isRequired,
    sellerId: PropTypes.string.isRequired,
    itemId: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    mode: PropTypes.string,
    t: PropTypes.func.isRequired
};

MessagingButton.defaultProps = {
    className: '',
    buyerId: '',
    sellerId: '',
    itemId: '',
    source: '',
    mode: 'link'
};

export default compose(withUrlLocalizer, withTranslator)(MessagingButton);
